import * as EwsReportListAction from './action';
const initialState = {
    ewsReportList: [],
    ewsReportListError: []
}

const EwsReportListReducer = (state = initialState, action) => {
    switch (action.type) {
        case EwsReportListAction.LIST_EWSREPORT_SUCCESS:
            return state = {
                ...state,
                ewsReportList: action.data
            }
        case EwsReportListAction.LIST_EWSREPORT_FAILURE:
            return state = {
                ...state,
                ewsReportListError: action.error
            }
            default: return state;
        }
    };

export default EwsReportListReducer;
